import React, { useState } from 'react';
import { Button, Paper } from '@mui/material';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import RHFTextArea from 'src/components/elements/TextArea/RHFTextArea';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { Loader } from 'src/components';
import { ChangeStatusProps, UpdateStatusValues } from '../../types';
import { jobStatusList } from '../../utils';

const ChangeStatusPopup = function ChangeStatusPopup(props: ChangeStatusProps) {
  const {
    jobOrderId, updateJobStatus, close,
  } = props;

  const validationSchema = yup.object().shape({
    status: yup.string().typeError('Select status to change').required('Change status required'),
    reason: yup.string().typeError('Select reason').required('Reason required'),
  });

  const resolver = useYupValidationResolver(validationSchema);

  const [loading, setLoading] = useState<boolean>(false);

  const methods = useForm<UpdateStatusValues>({
    resolver,
  });

  const { handleSubmit } = methods;

  const submitHandler: SubmitHandler<UpdateStatusValues> = async (data) => {
    try {
      const finalData = {
        ...data,
        jobOrderId,
      };
      setLoading(true);
      await updateJobStatus(finalData, close);
      setLoading(false);
    } catch (e) {
      console.info('...');
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <Paper
          className="px-4 rounded-md text-left"
          elevation={0}
        >
          <div className="pb-1 text-secondary text-center text-lg font-bold">
            Change Status
          </div>
          <div className="pb-16 text-secondary text-center text-sm">
            You have selected
            {' '}
            {jobOrderId.length}
            {' '}
            record(s)
          </div>
          <div className="pb-8">
            <div className="pb-8 flex flex-col gap-4">
              <div>
                <RHFSelect
                  control={methods.control}
                  name="status"
                  label="Change status to"
                  options={jobStatusList}
                />
              </div>
              <div>
                <RHFTextArea
                  control={methods.control}
                  name="reason"
                  label="Reason"
                  rows={5}
                />
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                type="submit"
                variant="contained"
                size="large"
              >
                Update
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={close}
              >
                Cancel
              </Button>
            </div>
          </div>
          {loading && (
          <div className="absolute top-[40%] left-[45%]">
            <Loader />
          </div>
          )}
        </Paper>
      </form>
    </FormProvider>
  );
};

export default ChangeStatusPopup;
